
import { Component, Vue, Watch, Prop } from "vue-property-decorator"
import { namespace, Getter, Mutation, Action } from "vuex-class"

// @ts-ignore
import VuePerfectScrollbar from "vue-perfect-scrollbar"
import { Case } from "@/types/case"
import SkeletonLoader from "../SkeletonLoader.vue"

import api from "@/services/api"

@Component({
	components: {
		"scrollbar": VuePerfectScrollbar,
		"skeleton": SkeletonLoader
	}
})
export default class Metrics extends Vue {
	@Prop()
	cellData: any;
}
